export default "__VITE_ASSET__8tb7H7iP__"